import { Box } from '@mui/material';

import { OneColumn } from 'components/page';
import { DreConfigGrupos, DreConfigList } from 'pages/financeiro/dre/configuracao/components';

export function DreConfig() {
    return (
        <OneColumn title="Configuração de Estimativa de Resultado" goBackButton>
            <Box
                sx={{
                    display: 'flex',
                    gap: 2,
                    alignItems: {
                        xs: 'stretch',
                        md: 'flex-start',
                    },
                    flexDirection: {
                        xs: 'column',
                        md: 'row',
                    },
                }}
            >
                <DreConfigGrupos />

                <DreConfigList />
            </Box>
        </OneColumn>
    );
}
